export default __webpack_public_path__ + "static/media/certificate_3.cf6a90e1.jpg";